import { faUserTie as IconeParticipacaoAdvogado } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GroupsIcon from '@mui/icons-material/Groups';
import RecordVoiceOver from '@mui/icons-material/RecordVoiceOver';
import VideoCameraFront from '@mui/icons-material/VideoCameraFront';
import { makeObservable, observable } from 'mobx';
import SituacaoInscricoesAdvogadosProcesso, {
    SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO
} from '../../dominio/SituacaoInscricoesAdvogadosProcesso';
import SituacaoInscricoesAdvogadosProcessoBusiness from '../../dominio/SituacaoInscricoesAdvogadosProcessoBusiness';
import ErrorUtil from '../../util/ErrorUtil';
import IconeAdvogado from '../sessao/icones/IconeAdvogado';
import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

export default class FiltroAdvogadoPreferenciaSustentacaoOralPresenca extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    tamanhoIcone = '22px';
    opacidade = '0.8';
    padding = '2px';

    get label() {
        return 'Advogados inscritos para preferência/sustentação oral';
    }

    getIconeFiltroRapido() {
        return (
            <IconeAdvogado
                removerTooltip
                removerEstiloPadrao
                style={{ width: '24px', height: '24px' }}
            />
        );
    }

    opcoesFiltro = FiltroAdvogadoPreferenciaSustentacaoOralPresenca.#carregarOpcoes();

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    filtroRapido = { opcoes: this.getOpcoesFiltro('valor', 'cor') };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={IconeParticipacaoAdvogado}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.cor,
                            backgroundColor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={IconeParticipacaoAdvogado}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE.cor,
                            backgroundColor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_PRESENCIALMENTE.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_PRESENCIALMENTE.cor,
                icone: (
                    <RecordVoiceOver
                        style={{
                            width: '28px',
                            height: '28px',
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_PRESENCIALMENTE.cor,
                            backgroundColor:
                                SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_PRESENCIALMENTE.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_TELEPRESENCIALMENTE.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_TELEPRESENCIALMENTE.cor,
                icone: (
                    <VideoCameraFront
                        style={{
                            width: '28px',
                            height: '28px',
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_TELEPRESENCIALMENTE.cor,
                            backgroundColor:
                                SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_PRESENTE_TELEPRESENCIALMENTE.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_AUSENTE.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_AUSENTE.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={IconeParticipacaoAdvogado}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_AUSENTE.cor,
                            backgroundColor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_AUSENTE.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_TODOS_ADV_AUSENTES.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_TODOS_ADV_AUSENTES.cor,
                icone: (
                    <GroupsIcon
                        style={{
                            width: '28px',
                            height: '28px',
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_TODOS_ADV_AUSENTES.cor,
                            backgroundColor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_TODOS_ADV_AUSENTES.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_SEM_INFORMACAO_PRESENCA.id,
                cor: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_SEM_INFORMACAO_PRESENCA.cor,
                icone: (
                    <FontAwesomeIcon
                        icon={IconeParticipacaoAdvogado}
                        style={{
                            width: this.tamanhoIcone,
                            height: this.tamanhoIcone,
                            color: SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_SEM_INFORMACAO_PRESENCA.cor,
                            backgroundColor:
                                SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_SEM_INFORMACAO_PRESENCA.corFundo,
                            fillOpacity: this.opacidade,
                            padding: this.padding
                        }}
                    />
                )
            }
        ];
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    get totalizador() {
        return SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO.COM_ADV_INSCRITO.id;
    }

    getValorOpcao(registro) {
        let situacoesCorrespondentes = [];

        try {
            let situacaoBusiness = new SituacaoInscricoesAdvogadosProcessoBusiness(registro);
            situacoesCorrespondentes = situacaoBusiness.getSituacoes();
        } catch (e) {
            console.error(ErrorUtil.montarMensagemErro(e));
        }

        return situacoesCorrespondentes;
    }

    getDescricao(valor) {
        return SituacaoInscricoesAdvogadosProcesso.getDescricao(valor);
    }
}
